// export const checkPermission = (feature, prviliege) => {
//     const data = JSON.parse(localStorage.getItem("permissions"));
//     const foundFeature = data?.filter((e) => e.code === feature);
//     console.log("",foundFeature);
//     if (!foundFeature?.length) return false;
//     return foundFeature[0]?.privileges.some((e) => e.code === prviliege);
//   };

export const checkPermission = (feature, privilege) => {
  const data = JSON.parse(localStorage.getItem("permissions"));
  const foundFeature = data?.filter((e) => e.code === feature);
  if (!foundFeature?.length) return false;
  let returnValue = false;
  foundFeature.forEach(element => {
    if(element.privileges.some((e) => e.code === privilege)){
      returnValue = true;
    }
  });
  return returnValue;
};
  